import { useEffect, useState } from 'react';
import {
  fetchHiddenPostsApi,
  fetchPostsApi,
} from '../../../api/admin/post.api';

export const useHiddenPostManagementHook = ({
  pageNumber,
  isRefetch,
}: {
  pageNumber?: number;
  isRefetch?: boolean;
}) => {
  const [posts, setPosts] = useState<any>();
  const [loading, setLoading] = useState<boolean>(false);
  useEffect(() => {
    getUsers(pageNumber);
  }, [pageNumber, isRefetch, status]);
  const getUsers = async (pageNumber) => {
    try {
      setLoading(true);
      const { data } = await fetchHiddenPostsApi(pageNumber);
      setPosts(data.data);
    } catch {
      //
    } finally {
      setLoading(false);
    }
  };
  return {
    data: posts,
    loading,
  };
};
